import NextLink from 'next/link'
import styled from 'styled-components'

import { theme } from 'styles/theme'

const { colors, fontSizes, fontWeights, media, radii, space, transitions, zIndices } = theme

export const AboutUs = styled.section`
  position: relative;
  width: 100%;
  overflow: hidden;
  background-color: ${colors['cashme-dark-blue']};
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-lg']};
  padding: ${space['spacing-xl']} 8.5rem ${space['spacing-xxl']};

  @media (${media.phone}) {
    padding: ${space['spacing-xl']} ${space['spacing-md']} ${space['spacing-xxl']};
  }

  @media (${media.desktop}) {
    flex-direction: row;
    align-items: center;
    gap: ${space['spacing-xxl']};
  }
`

export const TextColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-md']};

  @media (${media.desktop}) {
    flex: 1 1 50%;
    max-width: 32rem;
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-md']};
`

export const ButtonWrapper = styled.div`
  align-self: flex-start;
  margin-top: ${space['spacing-sm']};
`

export const ButtonLink = styled(NextLink)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${space['spacing-lg']};
  width: max-content;
  height: ${space['spacing-xxl']};
  min-height: ${space['spacing-xxl']};
  padding: 0 ${space['spacing-sm']};
  font-size: ${fontSizes['font-size-button']};
  font-weight: ${fontWeights['font-weight-medium']};
  color: ${colors['primary-text-strong']};
  background-color: ${colors['primary-background-strong-default']};
  border-radius: ${radii['corner-radius-pill']};
  transition: ${transitions.default};

  &:hover {
    color: ${colors['primary-text-strong']};
    background-color: ${colors['primary-background-strong-hover']};
  }
`

export const VideoColumn = styled.div`
  position: relative;
  width: 100%;

  @media (${media.desktop}) {
    flex: 1 1 50%;
  }
`

export const Decoration = styled.span`
  position: absolute;
  inset: 0;
  z-index: 0;
  transform: translate(${space['spacing-sm']}, ${space['spacing-sm']});
  border: 3px solid ${colors['cashme-magenta']};
  border-radius: ${radii['corner-radius-md']};
  pointer-events: none;
`

export const VideoFrame = styled.div`
  position: relative;
  z-index: ${zIndices[1]};
  border-radius: ${radii['corner-radius-md']};
  overflow: hidden;
`
